module.exports = __webpack_public_path__ + "static/media/size6.fbc11739.svg";